import { TwinIconProp } from '../../TwinIcon'
import { CustomRenderRoundedImage } from '../VirtualTableListing/CustomRenders'
import { Link } from 'react-router-dom'
import './twin_table_cards.sass'

interface TwinTableCardSimpleProps {
    id: string
    title: string
    icon: TwinIconProp
    img?: string
    className?: string
    classNameImg?: string
    children?: React.ReactNode
}

export const TwinTableCardSimple: React.FC<TwinTableCardSimpleProps> = ({ id, title, className, classNameImg, children, ...rest }) => {
    return (
        <div className={'twin_table_card flex justify-start rounded-lg bg-white  mr-15 ml-5 items-center ' + (className || '')}>
            <CustomRenderRoundedImage className={ (classNameImg || '') } name={title} {...rest} />
            <div className='flex-auto w-1 twin_elipsis '>
                <span className=''>{title}</span>
            </div>
            {children}
        </div>
    )
}

interface TwinTableCardProps extends TwinTableCardSimpleProps {
    basePath: string
    lastPath?: string
}

const TwinTableCard: React.FC<TwinTableCardProps> = ({ basePath, id, title, lastPath, ...rest}) => {
    return (
        <Link to={basePath + '/' + id + (lastPath ? '/' + lastPath : '')} className='twin_table_card_parent'>
            <TwinTableCardSimple className='p-20 w-300 my-10' classNameImg='mr-15 h-50 w-50 min-h-50 min-w-50' {...rest} id={id} title={title} />
        </Link>
    )
}

interface RenderTwinTableCardsProps {
    title: string
    twinTableCards: JSX.Element[]
    className?: string
}

export const RenderTwinTableCards: React.FC<RenderTwinTableCardsProps> = ({ title, className, twinTableCards}) => {
    return (
    <div className={className}>
        <div className='regular20'>{title}</div>
        <div className='flex flex-wrap'>
            {twinTableCards}
        </div>
    </div>)
}

export default TwinTableCard